/* unplugin-vue-components disabled */import script from "./setpassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./setpassword.vue?vue&type=script&setup=true&lang=ts"

import "./setpassword.vue?vue&type=style&index=0&id=26b0472e&scoped=true&lang=css"

import exportComponent from "D:\\openclawprogram\\sdjk123-vue - Copy (2)\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26b0472e"]])

export default __exports__